import React, { useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { useThree } from '@react-three/fiber';
import { downloadSnapshotState } from 'features/three-view/state/threeAtoms';
import { DesignSpaceViewer } from './DesignSpaceViewer';
import { ModelViewer } from './ModelViewer';
import { CocoonViewer } from './CocoonViewer';
import { TireViewer } from './TireViewer';
import { WheelhouseViewer } from './WheelhouseViewer';
import { MorphedViewer } from './MorphedViewer';
import { MorphingBoxViewer } from './MorphingBoxViewer';
import { GridControls } from './GridControls';
import { LightControls } from './LightControls';
import { downloadSnapshotClick } from '../utils/downloadSnapshotClick';

export const ThreeViewer: React.FC = () => {
  // gl/scene/camera は useEffect の依存配列に入れず、発火時に ref 経由で最新値を取得する。
  // 依存配列に camera を入れると、Perspective ⇄ Orthographic 切替 (makeDefault 変更) で
  // useThree().camera 参照が変わるたびに useEffect が再発火し、意図せず DL が走る。
  const three = useThree();
  const threeRef = useRef(three);
  threeRef.current = three;
  const isInitialRender = useRef(true);
  const downloadSnapshot = useRecoilValue(downloadSnapshotState);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    const { gl, scene, camera } = threeRef.current;
    downloadSnapshotClick(gl, scene, camera);
  }, [downloadSnapshot]);

  return (
    <>
      <DesignSpaceViewer />
      <ModelViewer />
      <CocoonViewer />
      <TireViewer />
      <WheelhouseViewer />
      <MorphedViewer />
      <MorphingBoxViewer />
      <LightControls />
      <GridControls />
      <axesHelper args={[10]} />
    </>
  );
};
